export default __webpack_public_path__ + "static/api-070b604269aab43bb50338720ee50248.png";